import moment from "moment"
import { get } from "../api"
import * as urls from "./urls"

const getJobsOptions = () => {
  return get(urls.GET_OPTIONS)
}

const getJobsExecutions = (filter, page = 1) => {
  const parsedFilters = {
    ...filter,
    page: page,
    jobs: filter?.jobs ? filter?.jobs?.map(j => j.value).toString() : null,
    status: filter?.status
      ? filter?.status?.map(j => j.value).toString()
      : null,
    startStartedAt: filter?.startStartedAt
      ? moment(filter?.startStartedAt).format("YYYY-MM-DD")
      : null,
    endStartedAt: filter?.endStartedAt
      ? moment(filter?.endStartedAt).format("YYYY-MM-DD")
      : null,
    startEndedAt: filter?.startEndedAt
      ? moment(filter?.startEndedAt).format("YYYY-MM-DD")
      : null,
    endEndedAt: filter?.endEndedAt
      ? moment(filter?.endEndedAt).format("YYYY-MM-DD")
      : null,
  }
  return get(urls.GET_EXECUTIONS, {
    params: {
      ...parsedFilters,
    },
  })
}

export { getJobsOptions, getJobsExecutions }
